import {AppConfig} from "../../pages/config/AppConfig";
import {creationMethod, program, STAGE_NAMES, swiftConfig} from "../constants/swiftConstants";
import {UPDATE_CREATION_METHOD, UPDATE_PROGRAM, UPDATE_PURPOSE} from "../redux/types/commonTypes";
import {BULK_TEMPLATE_FILES} from "../../pages/UnifiedMovementSystem/BulkCreateRequestContainer/resources/bulkCreateConfig";
import {
    HIDE_REQUEST_CONFIRMATION_MODAL,
    SHOW_REQUEST_CONFIRMATION_MODAL,
    TOGGLE_CREATE_REQUEST_BUTTON_CLICK,
    UPDATE_BASIC_DETAILS_LOWER_SECTION_VALIDATION_CHECK
} from "../redux/types/singleCreateRequestTypes";

export const currentConfig = swiftConfig.find(c =>
    c.cell === AppConfig.logConfigStageKey());

export const getProgramsByPurpose = (selectPurpose: string) => {
    return program.filter(item => item.purpose.includes(selectPurpose));
};

export const getCreationMethodByPurposeProgram = (selectPurpose: string, selectProgram: string) => {
    return creationMethod.filter(item => item.purpose.includes(selectPurpose) && item.program.includes(selectProgram));
}

export const onUpdatePurpose = (purpose, dispatch) => {
    dispatch({
        type: UPDATE_PURPOSE,
        payload: {
            selectPurpose: purpose
        }
    })
}

export const onUpdateProgram = (program, dispatch) => {
    dispatch({
        type: UPDATE_PROGRAM,
        payload: {
            selectProgram: program
        }
    })
}

export const onUpdateCreationMethod = (creationMethod, dispatch) => {
    dispatch({
        type: UPDATE_CREATION_METHOD,
        payload: {
            selectCreationMethod: creationMethod
        }
    })
}

export const getBulkCreateTemplateS3Url = () => {
    switch (currentConfig?.STAGE) {
        case STAGE_NAMES.ALPHA:
            return BULK_TEMPLATE_FILES.BULK_TEMPLATE_ALPHA;
        case STAGE_NAMES.BETA:
            return BULK_TEMPLATE_FILES.BULK_TEMPLATE_BETA;
        case STAGE_NAMES.PROD:
            return BULK_TEMPLATE_FILES.BULK_TEMPLATE_PROD;
    }
}

export const getProductionComponentBulkCreateTemplateS3Url = () => {
    switch (currentConfig?.STAGE) {
        case STAGE_NAMES.ALPHA:
            return BULK_TEMPLATE_FILES.PRODUCTION_COMPONENT_ALPHA;
        case STAGE_NAMES.BETA:
            return BULK_TEMPLATE_FILES.PRODUCTION_COMPONENT_BETA;
        case STAGE_NAMES.PROD:
            return BULK_TEMPLATE_FILES.PRODUCTION_COMPONENT_PROD;
    }
}

export const getUrlByStageName = (mapping) => {
    switch (currentConfig?.STAGE) {
        case STAGE_NAMES.ALPHA:
            return mapping.ALPHA;
        case STAGE_NAMES.BETA:
            return mapping.BETA;
        case STAGE_NAMES.PROD:
            return mapping.PROD;
        default:
            return mapping.DEV;
    }
}

export const onShowRequestConfirmationModal = (dispatch) => {
    dispatch({
        type: SHOW_REQUEST_CONFIRMATION_MODAL
    })
}

export const onHideRequestConfirmationModal = (dispatch) => {
    dispatch({
        type: HIDE_REQUEST_CONFIRMATION_MODAL
    })
}

export const onToggleCreateRequestButtonClick = (dispatch, payload) => {
    dispatch({
        type: TOGGLE_CREATE_REQUEST_BUTTON_CLICK,
        payload: payload
    })
}

export const onUpdateBasicDetailsLowerSectionValidationCheck = (dispatch, payload) => {
    dispatch({
        type: UPDATE_BASIC_DETAILS_LOWER_SECTION_VALIDATION_CHECK,
        payload: payload
    })
}

export const updateDestinationNames = (destinationSiteNames) => {
    destinationSiteNames.push({ label: "IAD022", value: "IAD022" });
    destinationSiteNames.push({ label: "PDX079", value: "PDX079" });
    destinationSiteNames.push({ label: "SAT011", value: "SAT011" });
    destinationSiteNames.push({ label: "DEN029", value: "DEN029" });
    destinationSiteNames.push({ label: "BWI012", value: "BWI012" });
}